<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      :ok-title="$t('common.ok')"
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('operation.city')}`
          : `${$t('common.edit')} ${$t('operation.city')}`
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="">
            <AutoComplete
              :label="$t('operation.governorate')"
              :placeholder="`${$t('common.select')} ${$t(
                'operation.governorate'
              )}`"
              v-model="EditForm.governorate_id"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="governorate"
              text-title="name"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('operation.cities')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t('common.filter') }} {{ $t('operation.cities') }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="cityNameFilter"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('operation.governorate')"
              :placeholder="`${$t('common.select')} ${$t(
                'operation.governorate'
              )}`"
              v-model="governrateFilter"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="governorate"
              text-title="name"
            />
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getCitiesList()">
              {{ $t('common.search') }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t('common.table') }} {{ $t('operation.cities') }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="$store.state.app.permissions.includes('store-city')"
          >
            {{ $t('common.create') }} {{ $t('operation.city') }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <!-- Dropdown -->
              <ActionsButtons
                deletePerm="delete-city"
                editPerm="update-city"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
                {{ $t('employee.employees') }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getCitiesList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BFormCheckbox,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormCheckbox,
    VuePhoneNumberInput,
    AutoComplete,
    ActionsButtons,
    DeleteModal,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: '',
        governorate_id: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        name: '',
        governorate_id: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        { key: 'name', label: this.$t('common.name'), sortable: true },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getCitiesList();
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true;
        this.EditForm = {
          name: '',
          governorate_id: '',
          _method: 'POST',
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.governorate_id = item.governorate_id;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-edit');
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getCitiesList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/city?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.cityNameFilter) {
        url += `&filter[name]=${this.cityNameFilter}`;
      }
      if (this.governrateFilter) {
        url += `&filter[governorate_id]=${this.governrateFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/city/${this.deleteForm.id}`)
        .then((response) => {
          this.getCitiesList();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.EditForm.is_surgery_room === false) {
        this.EditForm.is_surgery_room = 0;
      } else {
        this.EditForm.is_surgery_room = 1;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/city`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.getCitiesList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/city/${this.EditForm.id}`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              this.getCitiesList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
